import type { SignInOutputDto } from '@bldsoft/ovp-api-types'
import type { OVPUserSignInResponse } from '@setplex/tria-api'

export const formatSignInResponse = ({
  isFirstLogin,
  needFinishRegistration,
}: SignInOutputDto): OVPUserSignInResponse => ({
  isFirstLogin,
  needFinishRegistration,
})
